/** React SPA paths that render without AppShell (unauthenticated auth UI). */
export const REACT_PUBLIC_ROUTES = ['/login.html'] as const;

export function isReactPublicRoute(pathname: string): boolean {
  const normalized = pathname.replace(/\/+$/, '') || pathname;
  return (REACT_PUBLIC_ROUTES as readonly string[]).includes(normalized);
}
